import { useCallback } from 'react'
import { InputTableLayoutData, SetCompleteDataTy } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/types'

export interface useSelectOrderTableLogicProps {
    completeData: InputTableLayoutData
    setCompleteData: SetCompleteDataTy    
}
const ignoreTypes = ['addButton', 'productCombinedHeader', 'buyHeader', 'deliveryNoteHeader', 'invoiceHeader', 'sellHeader', 'sellDeliveryNoteHeader', 'sellInvoiceHeader']

export const useSelectOrderTableLogic = ({completeData, setCompleteData}: useSelectOrderTableLogicProps) => {
    const selectAllLines = useCallback((checked: boolean) => {
        setCompleteData((old) => {
            if (!old) {
                return null
            }
            const tableCopy = JSON.parse(JSON.stringify(old?.tableData))
            const parsedTableData = JSON.parse(JSON.stringify(old?.filteredTableData || old.tableData))
            const isFiltered = old?.filteredTableData?.length ? true : false
            const selectedTableData = []
            for (const key in parsedTableData) {
                let myElement = parsedTableData[key]
                if (isFiltered && old?.dictPosTableData?.[myElement.id]){
                    myElement = tableCopy[old?.dictPosTableData?.[myElement.id]]
                }
                if ((!myElement.type || !ignoreTypes.includes(myElement.type)) && !myElement.processed) {
                    myElement.selected = checked
                }
                const myTableCopyItem = tableCopy[myElement.absoluteIndex || parseInt(key)]
                if ((!myTableCopyItem.type || !ignoreTypes.includes(myTableCopyItem.type)) && !myTableCopyItem.processed) {
                    myTableCopyItem.selected = checked
                }
                if (myElement.selected && !myElement.processed){
                    selectedTableData.push({ id: myElement.id })
                }
            }
            if (old?.filteredTableData){
                old.filteredTableData = parsedTableData
            }
            return { ...old, tableData: tableCopy, selectedTableData: selectedTableData }
        })
    }, [setCompleteData])

    const changeSelectedOneLine = useCallback((checked: boolean, pos: number) => {
        setCompleteData((old) => {
            if (!old) {
                return null
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            if (copyOld?.tableData) {
                copyOld.tableData[pos]['selected'] = checked
                const myItem = copyOld.tableData[pos]
                if (myItem?.type === 'productCombinedHeaderAddon' || myItem?.OrderProductId) {
                    const OrderProductId = myItem.id
                    for (const element of copyOld?.tableData) {
                        if (element?.OrderProductId && element?.OrderProductId === OrderProductId) {
                            element['selected'] = checked
                        }
                    }
                }
                copyOld['selectedTableData'] = []
                if (copyOld.tableData) {
                    for (const key in copyOld.tableData) {
                        const element = copyOld.tableData[key]
                        if (element.processed) {
                        } else if (element.selected) {
                            copyOld.selectedTableData.push({id: element.id})
                        }
                    }
                }
            }
            return { ...copyOld }
        })
    }, [setCompleteData])

    const selectedLength = completeData.selectedTableData?.length || 0
    const processedLength = completeData.processedTableLength || 0

    return { selectAllLines, changeSelectedOneLine, selectedLength, processedLength }
}